import request from '@/utils/request'

// 查询列表
export function apiItemInventoryList (query) {
  return request({
    url: '/mdm/itemInventory/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiMdmItemInventoryNewExport (data) {
  return request({
    url: '/mdm/itemInventory/v2/export',
    method: 'post',
    data: data
  })
}

// 签价BOM
export function apiMdmGetSignBom (data) {
  return request({
    url: '/external/plm/getSignBom',
    method: 'post',
    data: data
  })
}

// 查询列表
export function apiItemInventoryDetailsList (query) {
  return request({
    url: '/mdm/itemInventory/detailsList',
    method: 'get',
    params: query
  })
}

// 物料范围
export function apiMdmItemOrganizationItemFindList (query) {
  return request({
    url: '/mdm/mdmItemOrganizationItem/findList',
    method: 'get',
    params: query
  })
}
